import { useState } from 'react';
import type { FormEvent } from 'react';
import { api, errorText } from '../api';
import { Card, Field, Notice } from '../components/ui';

export function PasswortPage() {
  const [alt, setAlt] = useState('');
  const [neu, setNeu] = useState('');
  const [wieder, setWieder] = useState('');
  const [meldung, setMeldung] = useState<{ art: 'error' | 'success'; text: string } | null>(null);

  async function speichern(e: FormEvent) {
    e.preventDefault();
    if (neu !== wieder) {
      setMeldung({ art: 'error', text: 'Die beiden neuen Passwörter stimmen nicht überein' });
      return;
    }
    try {
      await api('/api/auth/passwort', { method: 'POST', body: { altesPasswort: alt, neuesPasswort: neu } });
      setMeldung({ art: 'success', text: 'Passwort geändert.' });
      setAlt('');
      setNeu('');
      setWieder('');
    } catch (err) {
      setMeldung({ art: 'error', text: errorText(err) });
    }
  }

  return (
    <>
      <div className="kopf">
        <h1>Mein Passwort</h1>
      </div>
      <div style={{ maxWidth: 420 }}>
        {meldung && <Notice kind={meldung.art}>{meldung.text}</Notice>}
        <Card>
          <form className="stack" style={{ gap: 12 }} onSubmit={(e) => void speichern(e)}>
            <Field label="Bisheriges Passwort">
              <input type="password" autoComplete="current-password" value={alt} onChange={(e) => setAlt(e.target.value)} required />
            </Field>
            <Field label="Neues Passwort" hint="mindestens 10 Zeichen">
              <input type="password" autoComplete="new-password" value={neu} onChange={(e) => setNeu(e.target.value)} required minLength={10} />
            </Field>
            <Field label="Neues Passwort wiederholen">
              <input type="password" autoComplete="new-password" value={wieder} onChange={(e) => setWieder(e.target.value)} required />
            </Field>
            <div>
              <button type="submit" className="primary">
                Passwort ändern
              </button>
            </div>
          </form>
        </Card>
      </div>
    </>
  );
}
